import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const preferencesSchema = new schema.Entity(
  'preferences',
  {},
  { idAttribute: 'key' }
);

export const preferencesApi = individualKey =>
  apiResourceBuilder({
    name: `cuss/individual/${individualKey}/preferences`,
    idResolver: ({ key }) => key,
  });

export default individualKey => {
  const api = preferencesApi(individualKey);
  return entityActionCreator({ schema: preferencesSchema, api });
};



// WEBPACK FOOTER //
// ./src/App/account/actions/customers/preferences.js